import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {Checkbox as PolarisCheckbox, TextStyle, Button} from '@shopify/polaris';
import Input from './input';
import TextField from './textfield';

const collapsibleCutoff = 7;

class Checkbox extends Input {
  state = {
    collapsed: true,
  };

  toggleCollapsed = () => {
    this.setState(({collapsed}) => ({collapsed: !collapsed}));
  };

  constructor(props) {
    super(props);

    this.renderOption = this.renderOption.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.renderOtherInput = this.renderOtherInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  renderOption(option) {
    const {input} = this.props;
    const {value: selections = [], error} = input;

    return (
      <div key={option.value}>
        <PolarisCheckbox
          id={`${input.handle}-${option.value}`}
          name={input.handle}
          label={option.label}
          checked={selections.includes(option.value)}
          onChange={this.handleChange(option)}
          helpText={this.renderHelpText(option)}
          error={Boolean(error)}
        />
      </div>
    );
  }

  handleChange(option) {
    const {input} = this.props;
    const {value: selections = []} = input;

    return selected => {
      let newValue;

      if (selected) {
        newValue = [...selections, option.value];
      } else {
        newValue = selections.filter(selection => selection !== option.value);
      }

      Input.prototype.handleChange.call(this, newValue);
    };
  }

  handleSelectAll(value) {
    const {input} = this.props;
    const newValue = value ? input.options.map(option => option.value) : [];

    Input.prototype.handleChange.call(this, newValue);
  }

  renderHelpText(option) {
    const otherInput = this.renderOtherInput(option);
    const helpText = option.helpText ? (
      <TextStyle>{option.helpText}</TextStyle>
    ) : null;

    if (otherInput || helpText) {
      return (
        <div>
          {helpText}
          {otherInput}
        </div>
      );
    } else {
      return null;
    }
  }

  renderOtherInput(option) {
    const {input, questionId} = this.props;
    const {value: selections = []} = input;
    const {otherId} = option;
    let component = null;

    selections.forEach(selection => {
      if (selection === option.value && otherId) {
        component = <TextField inputId={otherId} questionId={questionId} />;
      }
    });

    return component;
  }

  renderSelectAll() {
    const {input} = this.props;
    const {selectAllLabel, options, value: selections = []} = input;

    return selectAllLabel ? (
      <div>
        <PolarisCheckbox
          label={selectAllLabel}
          checked={options.length === selections.length}
          onChange={this.handleSelectAll}
        />
      </div>
    ) : null;
  }

  _render() {
    const {collapsed} = this.state;
    const {input} = this.props;
    const {options} = input;
    const className = classNames(
      'sm-question__inputs',
      collapsed && 'sm-question__inputs--collapsed'
    );

    return (
      <div className={className}>
        {options.map(this.renderOption)}
        {options.length > collapsibleCutoff && (
          <Button plain onClick={this.toggleCollapsed}>
            {collapsed ? 'See all' : 'See less'}
          </Button>
        )}
        {this.renderSelectAll()}
        {this.renderErrorMessage()}
      </div>
    );
  }
}

export default connect(
  Checkbox.mapStateToProps,
  Checkbox.mapDispatchToProps
)(Checkbox);
